module.exports = __webpack_public_path__ + "img/filter-by-threat-feeds.8ddc98a7.png";